import { Switch } from "antd";

import "./CustomSwitch.css"
const CustomSwitch = ({ checked, onChange, disabled = false, ...props }) => {
  return (
    <Switch
     className="custom-switch"
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      style={{
        backgroundColor: checked ? 'rgba(145, 14, 17, 1)' : 'rgba(0, 0, 0, 0.25)',
      }}
      {...props}
    />
  );
};

export default CustomSwitch;